const orderRoutes = [
	{
		path: '/ODToBePaid',	//待支付
		name: 'ODToBePaid',
		component: () => import('../views/Order/ODToBePaid.vue'),
	},
	{
		path: '/ODOngoing',		//进行中
		name: 'ODOngoing',
		component: () => import('../views/Order/ODOngoing.vue'),
	},
	{
		path: '/ODCompleted',	//过期|已完成订单
		name: 'ODCompleted',
		component: () => import('../views/Order/ODCompleted.vue'),
	},
	{
		path: '/ODRefund',		//退款订单
		name: 'ODRefund',
		component: () => import('../views/Order/ODRefund.vue'),
	},
	{
		path: '/ApplyRefund',	//退款提交
		name: 'ApplyRefund',
		component: () => import('../views/Order/ApplyRefund.vue'),
	}
]

export default orderRoutes;